module.exports = __webpack_public_path__ + "static/media/ana_marrom.be67d5fd.png";